import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";
import "./modal.scss";
import TruncatedTextTooltip from "../TruncatedTextTooltip";

const BootstrapDialogTitle = (props) => {
  const { children, onClose, closeIcon, ...other } = props;
  return (
    <DialogTitle {...other}>
      {children}
      {closeIcon ? (
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
export const Modal = ({
  handleClose,
  open,
  maxWidth,
  title,
  body,
  footer,
  closeIcon,
  className,
  isStickyContent,
  isError,
  errorMsg,
  ..._props
}) => {
  const classes = classNames("modal", className);
  return (
    <Dialog
      onClose={closeIcon ? null : handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={maxWidth}
      className={classes}
      fullWidth
      disableEscapeKeyDown
      {..._props}
    >
      {title && (
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          closeIcon={closeIcon}
        >
          <TruncatedTextTooltip
            textProps={{
              className: "default-text",
              font: "semibold",
              variant: "body1",
            }}
            textValue={title}
            cellWidth="250px"
            fontSize={18}
          />
        </BootstrapDialogTitle>
      )}

      <DialogContent dividers>{body}</DialogContent>
      {footer && <DialogActions>{footer}</DialogActions>}
    </Dialog>
  );
};
